export const buildClassStudentsForShareDownload = (
  allAssignedStudents = [],
  studentsSubmissions = [],
  currentUserId = null,
) => {
  // The viewer is never a student to share with or download for: on a My Draft
  // their own row is the draft itself (JED-1296).
  const isViewer = (id) =>
    currentUserId != null && String(id) === String(currentUserId);
  const isLiveStudentRow = (entry) =>
    entry?.status !== 'DRAFT' &&
    entry?.status !== 'DELETED' &&
    entry?.studentId &&
    !isViewer(entry.studentId);

  const submissionsByStudentId = new Map();
  studentsSubmissions
    .filter(isLiveStudentRow)
    .forEach((entry) => {
      const ids = submissionsByStudentId.get(entry.studentId) || [];
      if (entry.submissionId && !ids.includes(entry.submissionId)) ids.push(entry.submissionId);
      submissionsByStudentId.set(entry.studentId, ids);
    });

  const seen = new Set();
  const roster = [];

  (allAssignedStudents || []).forEach((student) => {
    const id = student?.id ?? student?.studentId;
    if (!id || seen.has(id) || isViewer(id)) return;
    seen.add(id);
    roster.push({
      id,
      name: student.name || student.studentName || 'Student Name',
      studentName: student.studentName || student.name || 'Student Name',
      submissionId: submissionsByStudentId.get(id)?.[0] || null,
      submissionIds: submissionsByStudentId.get(id) || [],
    });
  });

  studentsSubmissions
    .filter(isLiveStudentRow)
    .forEach((entry) => {
      if (seen.has(entry.studentId)) return;
      seen.add(entry.studentId);
      roster.push({
        id: entry.studentId,
        name: entry.studentName || 'Student Name',
        studentName: entry.studentName || 'Student Name',
        submissionId: submissionsByStudentId.get(entry.studentId)?.[0] || null,
        submissionIds: submissionsByStudentId.get(entry.studentId) || [],
      });
    });

  return roster.sort((a, b) => a.name.localeCompare(b.name));
};
